import Immutable from "immutable";

const settingsActivityMap = Immutable.Map({
  requestMore: true,
  loadingMore: false
});

export const settingsActivity = (state = settingsActivityMap, action) => {
  switch (action.type) {
    case "GET_MORE_ACTIVITIES_REQUEST":
      return state.set("loadingMore", true);
    case "GET_ACITVITIES_SUCCESS":
    case "GET_MORE_ACITVITIES_SUCCESS":
      return state.merge({
        requestMore: action.response.data.activitys.length === 10,
        loadingMore: false
      });
    case "GET_MORE_ACITVITIES_FAILURE":
      return state.set("loadingMore", false);
    default:
      return state;
  }
};
